// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Wjir","left":"styles_left__qPIM2","desktopActions":"styles_desktopActions__1epYE","title":"styles_title__29PUA"};